import React, { useEffect, useRef, useState } from "react"
import $ from "jquery"
import "select2/dist/css/select2.min.css"
import "select2"
import Config from "../Config"

const SkillsMultiSelect = ({
  professionalCategory,
  professionalSubCategory,
  handleSkillsInput,
  existingValues = [],
  onKeyDown,

}) => {
  console.log(existingValues);

  
  const selectRef = useRef(null);
  const [selectedValues, setSelectedValues] = useState([]);
  const [eValues, setEValues] = useState(existingValues);
 
  useEffect(() => {
    const selectElement = $(selectRef.current)

    selectElement.select2({
      placeholder: "Select skills",
      ajax: {
        url: `${Config.apiurl}/api/v1/common/skills`,
        dataType: "json",
        delay: 250,
        data: function (params) {
          return {
            category: professionalCategory,
            subCategory: professionalSubCategory,
            keyString: params.term,
          }
        },
        processResults: function (data) {
      
      
            const transformedArray = data.data.reduce((result, obj) => {
            const {
              levelOneId,
              levelOneName,
              levelTwoId,
              levelTwoName,
              levelThreeId,
              levelThreeName,
              levelFourId,
              levelFourName,
            } = obj;
        
            // Level Three
            const levelThreeObj = {
              id: JSON.stringify({
                levelOneId,
                levelOneName,
                levelTwoId,
                levelTwoName,
                levelThreeId,
                levelThreeName,
              }),
              text: levelThreeName,
            };
            if (
              !result.some(
                (item) =>
                  JSON.parse(item.id).levelThreeId ===
                  JSON.parse(levelThreeObj.id).levelThreeId
              ) 
             
            ) {
              result.push(levelThreeObj);
            }
        
            // Level Four
            const levelFourObj = {
              id: JSON.stringify({
                levelOneId,
                levelOneName,
                levelTwoId,
                levelTwoName,
                levelThreeId,
                levelThreeName,
                levelFourId,
                levelFourName,
              }),
              text: levelFourName,
            };
            if (
              !result.some(
                (item) =>
                  JSON.parse(item.id).levelFourId ===
                  JSON.parse(levelFourObj.id).levelFourId
              ) 
            ) {
              result.push(levelFourObj);
            }
    
            return result;
          }, []);
        
          return {
            results: transformedArray.map((skill) => ({
              id: skill.id,
              text: skill.text,
            })),
          };
        },
        
        cache: true,
      },
      minimumInputLength: 1,
      templateResult: function (skill) {
        return skill.text
      },
      templateSelection: function (skill) {
        return skill.text
      },
    })

    selectElement.on("change", function (e) {
      const selectedOptions = selectElement.val();
      handleSkillsInput(selectedOptions);
      setSelectedValues(selectedOptions);
    });
  
    // Listen for changes and update eValues
    // selectElement.on("select2:unselect", function (e) {
      
    //   const removedValue = e.params.data;
    //   // Filter out the removed value from eValues
    //   setEValues((prevEValues) =>
    //     prevEValues.filter(
    //       (value) =>
    //         JSON.stringify(value.value) !== JSON.stringify(removedValue.id)
    //     )
    //   );
  
    //   // Update selectedValues by removing the unselected value
    //   setSelectedValues((prevSelectedValues) =>
    //     prevSelectedValues.filter(
    //       (value) =>
    //         JSON.stringify(value) !== JSON.stringify(removedValue)
    //     )
    //   );
    
    // });
    selectElement.on("select2:unselect", function (e) {
      const removedValue = e.params.data;
      // Filter out the removed value from eValues
      setEValues((prevEValues) =>
        prevEValues.filter(
          (value) =>
            JSON.stringify(value.value) !== JSON.stringify(removedValue.id)
        )
      );
    
      // Update selectedValues by removing the unselected value
      setSelectedValues((prevSelectedValues) =>
        prevSelectedValues.filter(
          (value) =>
            JSON.stringify(value) !== JSON.stringify(removedValue)
        )
      );
    
      // Force re-render to reflect changes in options
     
    });
  
    // Cleanup the Select2 instance on component unmount
    return () => {
      selectElement.off("select2:unselect");
      selectElement.off("change");
      selectElement.select2("destroy");
    };
  // }
  }, [eValues, professionalCategory, professionalSubCategory,handleSkillsInput, existingValues, selectedValues])


  // useEffect(() => {
  //   const selectElement = $(selectRef.current)
  //   // Append existing values as options
  //   eValues.forEach((value) => {
  //     const option = new Option(
  //       value.text,
  //       JSON.stringify(value.value),
  //       true,
  //       true
  //     )
  //     selectElement.append(option)
  //   })

  //   // Trigger change event after appending options
  //   selectElement.trigger("change")
  // }, [])

  useEffect(() => {
    const selectElement = $(selectRef.current);
  
    // Clear previous options
    selectElement.empty();
  
    eValues.forEach((value) => {
      const option = new Option(
        value.text,
        JSON.stringify(value.value),
        true,
        true
      );
      selectElement.append(option);
    });
  
    // Trigger change
    selectElement.trigger("change");
  }, [eValues]);
  

  // Handle change event
  useEffect(() => {
    const selectElement = $(selectRef.current)

    selectElement.on("change", function (e) {
      const selectedOptions = selectElement.val()
      handleSkillsInput(selectedOptions)
      setSelectedValues(selectedOptions)
    })

    return () => {
      selectElement.off("change")
    }
  }, [handleSkillsInput,eValues])
// useEffect(()=>{
//   console.log(existingValues);
//   if(existingValues.length===0){

//   selectRef.current=null;
//   }
// },[existingValues.length])


useEffect(()=>{
 setEValues(existingValues);
 if(existingValues.length===0){
  setSelectedValues([]);
 }
 
},[existingValues.length])

useEffect(() => {
  if (selectRef.current) {
    selectRef.current.scrollTop = 0;
  }
}, [selectedValues]);

  return (
    <>
      {professionalCategory && professionalSubCategory?
      <select
        ref={selectRef}
        multiple
        style={{ width: "300px" }}
        className="form-control"
        onKeyDown={onKeyDown}
        value={existingValues.length > 0 ? selectedValues.map(value => (value)) : selectedValues.length>0?selectedValues.map(value => (value)):[]}
      ></select>
          :
          <select
          disabled
          ref={selectRef}
          multiple
          style={{ width: "300px" }}
          className="form-control"
          onKeyDown={onKeyDown}
          value={existingValues.length > 0 ? selectedValues.map(value => (value)) : selectedValues.length>0?selectedValues.map(value => (value)):[]}
        ></select>
        }
    </>
  )
}

export default SkillsMultiSelect
